import { render, staticRenderFns } from "./StatCards.vue?vue&type=template&id=3e2a19aa&scoped=true&"
import script from "./StatCards.vue?vue&type=script&lang=js&"
export * from "./StatCards.vue?vue&type=script&lang=js&"
import style0 from "./StatCards.vue?vue&type=style&index=0&id=3e2a19aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2a19aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e2a19aa')) {
      api.createRecord('3e2a19aa', component.options)
    } else {
      api.reload('3e2a19aa', component.options)
    }
    module.hot.accept("./StatCards.vue?vue&type=template&id=3e2a19aa&scoped=true&", function () {
      api.rerender('3e2a19aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statistics/components/MarketPlace/StatCards.vue"
export default component.exports